export const fetchAuthToken = (isRefresh = false) =>
  ({ type: 'auth.fetch-auth-token', payload: { isRefresh } } as const)
export type FetchAuthTokenAction = ReturnType<typeof fetchAuthToken>

export const fetchAuthTokenSuccess = (
  authToken: string,
  userName: string,
  userId?: string
) =>
  ({
    type: 'auth.fetch-auth-token-success',
    payload: { authToken, userName, userId }
  } as const)
export type FetchAuthTokenSuccessAction = ReturnType<
  typeof fetchAuthTokenSuccess
>

export const fetchAuthTokenFailure = (error: any) =>
  ({
    type: 'auth.fetch-auth-token-failure',
    error: true,
    payload: error
  } as const)
export type FetchAuthTokenFailureAction = ReturnType<
  typeof fetchAuthTokenFailure
>

export const redirectToLogin = () =>
  ({ type: 'auth.redirect-to-login' } as const)
export type RedirectToLoginAction = ReturnType<typeof redirectToLogin>

export const setAuthInitialized = () =>
  ({ type: 'auth.setAuthInitialized' } as const)
export type SetAuthInitializedAction = ReturnType<typeof setAuthInitialized>

export type AuthAction =
  | FetchAuthTokenAction
  | FetchAuthTokenSuccessAction
  | FetchAuthTokenFailureAction
  | RedirectToLoginAction
  | SetAuthInitializedAction
